import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import BackButton from "../img/back-button.png"
import LogoDarkAnimator from '../../componetns/logoDarkAnimator'
import MobileHeader from "./mobileHeader";
import * as ctf from "contentful";
import {
  AnimatedBlock,
  interpolate,
  useAnimatedValue,
  useScroll,
} from "react-uicomp";
import $ from "jquery";
import "animate.css";
const MobileProjects = () => {
  const [projects, setProjects] = useState([]);

  const [y, setY] = useState(document.scrollingElement.scrollHeight);
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  const [detectScroll, setDetectScroll] = useState(false);

  const velocityY = useAnimatedValue(0);

  useScroll((event) => {
    velocityY.value = event.velocityY;
  });

  // let userHasScrolled = false;
  window.addEventListener("scroll", (e) => {
    setDetectScroll(true);
  });

  console.log("Scroll Detect", detectScroll);

  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
        console.log("scrolling up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
        console.log("scrolling down");
      }
      setY(window.scrollY);
    },
    [y]
  );

  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  const client = ctf.createClient({
    space: "fdtw7gymput4",
    accessToken: "-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E",
  });

  var position = $(window).scrollTop();
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll > position) {
      $(".pensons_circle").css("animation", "linkListAnimation 2s");
      $(".pensons_circle").css("animation-direction", "alternate");
      // $(".rotate-img").addClass("linkList");
    } else {
      $(".pensons_circle").css("animation", "linkListAnimation 2s");
      $(".pensons_circle").css("animation-direction", "alternate");
      $(".rotate-img").addClass("linkList");
    }
    position = scroll;
  });

  useEffect(() => {
    fetchDataProject();
  }, []);

  const fetchDataProject = async () => {
    try {
      const resp = await client.getEntries({ content_type: "projects" });
      setProjects(resp.items);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ background: "#000" }}>
      <div className="Mobile_header">
        <Link to="/" className=" mobile_back" style={{ border: 'none', marginTop: '.5rem', marginLeft: '.5rem' }} >
          <img src={BackButton} alt="" />
        </Link>
        {/* <img src={LogoMain} alt="logo" /> */}
        <Link to="/">
          <LogoDarkAnimator />
        </Link>
        <div className=""></div>
      </div>
      <div className="project-menu ">
        <ul>
          {projects != null &&
            projects.map((item, index) => {
              return (
                <AnimatedBlock
                  key={index}
                  style={{
                    transform: interpolate(
                      velocityY.value,
                      [-3, 0, 1],
                      ["skewY(-5deg)", "skewY(0deg)", "skewY(5deg)"]
                    ),
                  }}
                >
                  <li
                    className="linkList"
                    style={{ display: "inline !important" }}
                  >
                    <Link to={`/projects/${item?.sys?.id}`}>
                      {item?.fields?.title}
                    </Link>
                  </li>
                </AnimatedBlock>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default MobileProjects;
